import axios from "axios";
import {
  toolbarOptions,
  renderingEditorModalDynamically,
} from "@/Helpers/EditorHelper";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { Editor } from "react-draft-wysiwyg";
import { Strings } from "@/resources";
import DOMPurify from "dompurify";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function DraftEditor({
  editorState,
  handleEditorStateChange,
  id = undefined,
}: {
  editorState: any;
  handleEditorStateChange: any;
  id?: number | undefined;
}) {
  function uploadImageCallBack(file: File) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("image", file);

      axios
        .post(route("wysiwyg-editor.upload"), formData)
        .then((response) => resolve(response.data))
        .catch((error) => {
          toast.error(error?.response?.data?.message ?? Strings.general_error);
          reject(error);
        });
    });
  }

  useEffect(() => {
    renderingEditorModalDynamically();
  }, []);

  return (
    <Editor
      wrapperId={id}
      editorState={editorState}
      wrapperClassName="ck-editor"
      toolbarClassName="ck-editor-toolbar"
      editorClassName="ck-editor-inner"
      onEditorStateChange={(e) => handleEditorStateChange(e)}
      toolbar={{
        options: toolbarOptions,
        image: { uploadCallback: uploadImageCallBack },
      }}
    />
  );
}

export function sanitizeHtml(content: string | Node) {
  return DOMPurify.sanitize(content);
}
